(function () {

    async function pow_bit(data, bits, count) {
        if (bits >= 32) throw new Error('bits must be below 32');
        if (count >= 16) throw new Error('count must be below 16');
        const token = new TextEncoder().encode(data);
        const input = new Uint8Array(token.length + 10);
        input.set(token);
        const mask = (1 << bits) - 1;
        const nonces = new Array(count);
        const check = Array.from(nonces).map((_,i) => i);
        let nonce = 0;
        while (check.length) {
            const chars = '' + ++nonce;
            for (let i = 0; i < chars.length; ++i){
                input[token.length + i] = chars.charCodeAt(i);
            }
            const hash = new Uint32Array(
                await crypto.subtle.digest('SHA-512', input.subarray(0, token.length + chars.length))
            );
            for (let i = 0; i < check.length; ++i) {
                if (!(hash[check[i]] & mask)) {
                    nonces[check[i]] = nonce;
                    check.splice(i, 1);
                    i--;
                }
            }
        }
        return nonces;
    }

    async function send(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const form_elem = evt.target;

        const butt = form_elem.querySelector('button[type="submit"]');
        butt.setAttribute("disabled", 'disabled');

        let form_data = new FormData(form_elem);
        if (form_data.get("_challenge")) {
            let [token, difficulty, count] = form_data.get('_challenge').split(",");
            difficulty = parseInt(difficulty);
            count = parseInt(count);
            const nonces = await pow_bit(token, difficulty, count)
            const new_elem = document.createElement('input');
            new_elem.setAttribute("type", "hidden");
            new_elem.setAttribute("name", "_challenge_response");
            new_elem.value = JSON.stringify(nonces);
            form_elem.appendChild(new_elem);
        }

        const url = form_elem.getAttribute("data-url");
        form_data = new FormData(form_elem);

        const response = await fetch(url, {
            method: "post",
            body: form_data,
            cache: "no-cache",
            redirect: "manual",
        })
        if (response.status === 201) {
            const target = response.headers.get("x-redirect-to");
            if (target)
                window.location.href = target;
            return null;
        }
        const txt = await response.text();
        if (txt)
            form_elem.innerHTML = txt;
    }

    document.querySelectorAll("form.custom-form").forEach(form_elem => form_elem.onsubmit = send);
})();
